import { type CacheConfig, Network, type RequestParameters, type Variables } from 'relay-runtime';

import { BatchFetcher, DEFAULT_BATCHING_CONFIG } from './utils/batch-fetcher';

const fetchFn = async (
	request: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
) => {
	const batchFetcher = new BatchFetcher(DEFAULT_BATCHING_CONFIG);
	return await batchFetcher.fetch(request, variables, cacheConfig);
};

export const network = Network.create(fetchFn);
